module.exports = __webpack_public_path__ + "img/rectang_disable.45b987b5.svg";